import { UploadedDocumentInfoDocumentType } from '@urbanx/agx.campaigns.client';
import { DocumentTypesMap } from '@urbanx/agx-ui-components';
import type {
  DocumentGroup,
  StaffContractDetailModel,
  UploadedDocument,
  UploadedDocumentInfo,
} from '@urbanx/agx.campaigns.client';

const getDocumentKey = (document: UploadedDocument) =>
  [
    document.containerName,
    document.documentType,
    document.containerFilePath,
    document.documentId,
    document.fileName,
  ]
    .filter(Boolean)
    .join('/');

const toUploadedDocumentInfo = (document: UploadedDocument): UploadedDocumentInfo => ({
  ...document,
  title: DocumentTypesMap[document.documentType as keyof typeof DocumentTypesMap],
  documentType: document.documentType as unknown as UploadedDocumentInfoDocumentType,
});

export const getExchangeTaskDocumentGroups = (
  contract?: StaffContractDetailModel
): DocumentGroup[] => {
  const seen = new Set<string>();
  const documents = [
    ...Object.values(contract?.contractDocuments ?? {}),
    ...(contract?.documents ?? []),
  ]
    .filter((document): document is UploadedDocument => !!document?.containerFilePath)
    .filter((document) => {
      const key = getDocumentKey(document);
      if (seen.has(key)) return false;

      seen.add(key);
      return true;
    })
    .map(toUploadedDocumentInfo);

  return documents.length > 0
    ? [
        {
          title: contract?.contractName ?? 'Contract Documents',
          documents,
        },
      ]
    : [];
};
